import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

import type { SessionClientBootstrap } from "@/lib/identity-setup"

/** Snapshot from the `session` command (`workspace` / `user` keys). */
export type SessionBootstrapPayload = SessionClientBootstrap

type SessionBootstrapState = {
  status: "idle" | "loading" | "succeeded" | "failed"
  data: SessionBootstrapPayload | null
  error: string | null
}

const initialState: SessionBootstrapState = {
  status: "idle",
  data: null,
  error: null,
}

const sessionBootstrapSlice = createSlice({
  name: "sessionBootstrap",
  initialState,
  reducers: {
    sessionBootstrapReceived(state, action: PayloadAction<SessionBootstrapPayload>) {
      state.status = "succeeded"
      state.data = action.payload
      state.error = null
    },
    resetSessionBootstrap() {
      return initialState
    },
  },
})

export const { sessionBootstrapReceived, resetSessionBootstrap } = sessionBootstrapSlice.actions
export const sessionBootstrapReducer = sessionBootstrapSlice.reducer

export function selectHasPhoneSystem(state: { sessionBootstrap: SessionBootstrapState }): boolean {
  return state.sessionBootstrap.data?.workspace.has_phone_system ?? false
}
